// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141636/js/" + chunkId + "." + {"44":"cc4576c6","225":"a040f865","481":"4e75aaa5","486":"d71b8413","770":"9dade8d6"}[chunkId] + ".0.6283285718788838.chunk.js";
};